
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/org/[slug]/panel/inicio",
      function () {
        return require("private-next-pages/org/[slug]/panel/inicio.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/org/[slug]/panel/inicio"])
      });
    }
  